import React from "react";
import Grid from "@mui/material/Grid";
import { getAssets } from "@unisearch/helpers";
import styles from "./counsellor_partner.module.scss";

export const CounsellorPartner = () => {
  return (
    <section className={styles.section_partner}>
      <div className="container">
        <h2 className={`${styles.title} center`}>Our Patrners</h2>
        <p className={`${styles.sub_title} font-xlarge center`}>
          Trusted by 1,300+ institutions globally
        </p>

        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            lg={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={getAssets(
                "assets/images/partner/kings_college_london_logo.png"
              )}
              alt="Kings College London"
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            lg={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={getAssets(
                "assets/images/partner/australian_national_university.png"
              )}
              alt="Australian National University"
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            lg={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={getAssets(
                "assets/images/partner/univesity_of_cincinnaty.png"
              )}
              alt="Univesity of cincinnaty"
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            lg={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={getAssets(
                "assets/images/partner/university_of_manitoba.png"
              )}
              alt="University of Manitoba"
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            lg={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={getAssets("assets/images/partner/university_of_york.png")}
              alt="University of York"
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            lg={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={getAssets("assets/images/partner/hec_paris.png")}
              alt="HEC Paris"
            />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default CounsellorPartner;
